import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { Role } from '../types';

interface RoleProtectedRouteProps {
  children: React.ReactNode;
  adminOnly?: boolean;
  managerOnly?: boolean;
  cashierAllowed?: boolean;
}

const RoleProtectedRoute: React.FC<RoleProtectedRouteProps> = ({
  children,
  adminOnly = false,
  managerOnly = false,
  cashierAllowed = false
}) => {
  const user = useSelector((state: RootState) => state.auth.user);

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Admin can access everything
  if (user.role === Role.ADMIN) {
    return <>{children}</>;
  }

  // Both Manager and Cashier can only access cashierAllowed items (the 4 basic pages)
  if (user.role === Role.MANAGER || user.role === Role.CASHIER) {
    if (cashierAllowed) {
      return <>{children}</>;
    }
  }

  // User doesn't have permission, redirect to their default page
  return <Navigate to="/sales" replace />;
};

export default RoleProtectedRoute;